import type { Bounds, MapBounds } from './interfaces';
import { getLocation } from '.';

export const getBoundsFromMapResult = (mapBounds: MapBounds): Bounds => {
  const ne = mapBounds.getNorthEast();
  const sw = mapBounds.getSouthWest();

  const north = ne.lat();
  const east = ne.lng();
  const south = sw.lat();
  const west = sw.lng();

  return {
    nw: {
      lat: north,
      lng: west,
    },
    ne: {
      lat: north,
      lng: east,
    },
    se: {
      lat: south,
      lng: east,
    },
    sw: {
      lat: south,
      lng: west,
    },
  };
};

export const parseReverseGeocodeResults = (geocodeResponse: google.maps.GeocoderResult[]) => {
  if (!geocodeResponse) {
    return {};
  }

  const [reverseGeocodeResult] = geocodeResponse;

  let regionCode = null;
  let countryCode = null;
  let city = null;

  const foundRegionComponent = reverseGeocodeResult.address_components.find((component) => component.types.indexOf('administrative_area_level_1') !== -1);

  if (foundRegionComponent) {
    regionCode = foundRegionComponent.short_name;
  }

  const foundCountryComponent = reverseGeocodeResult.address_components.find((component) => component.types.indexOf('country') !== -1);

  if (foundCountryComponent) {
    countryCode = foundCountryComponent.short_name;
  }

  // The city name can be hidden in multiple components
  // Search "locality", "postal_town", and "administrative_area_level_3"
  let foundCityComponent = reverseGeocodeResult.address_components.find((component) => component.types.indexOf('locality') !== -1);

  if (foundCityComponent) {
    city = foundCityComponent.long_name;
  }

  if (!city) {
    foundCityComponent = reverseGeocodeResult.address_components.find((component) => component.types.indexOf('administrative_area_level_3') !== -1);

    if (foundCityComponent) {
      city = foundCityComponent.long_name;
    }
  }

  if (!city) {
    foundCityComponent = reverseGeocodeResult.address_components.find((component) => component.types.indexOf('postal_town') !== -1);

    if (foundCityComponent) {
      city = foundCityComponent.long_name;
    }
  }

  if (!city) {
    foundCityComponent = reverseGeocodeResult.address_components.find((component) => component.types.indexOf('sublocality') !== -1);

    if (foundCityComponent) {
      city = foundCityComponent.long_name;
    }
  }

  return {
    city,
    countryCode,
    regionCode,
    latLng: getLocation(reverseGeocodeResult.geometry.location),
    googlePlaceId: reverseGeocodeResult.place_id,
  };
};
